import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getClientes,
  deleteCliente,
  getClienteById,
} from "../helpers/rutaClientes";
import ModalCliente from "./ModalCliente";
import "../css/tableclientes.css";

const TableClientes = () => {
  const [clientes, setClientes] = useState({
    data: {},
    loading: true,
  });

  const [cliente, setCliente] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaClientes();
  }, []);

  const consultaClientes = () => {
    getClientes().then((datos) => {
      console.log("📦 Clientes:", datos);
      setClientes({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaClientes();
  };

  const handleShow = () => setShow(true);

  const modificaCliente = (id) => {
    getClienteById(id).then((resp) => {
      if (resp.ok) {
        setCliente(resp.cliente); // ✅ ahora sí solo el objeto cliente
        handleShow();
      } else {
        console.error("❌ Error al obtener cliente:", resp.error);
      }
    });
  };

  const eliminarCliente = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el cliente?");
    if (confirmar) {
      deleteCliente(id).then(() => {
        consultaClientes();
      });
    }
  };

  return (
    <div className="table-container">
      {!clientes.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th className="acciones">Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Razón Social</th>
                  <th className="dom">Domicilio</th>
                  <th className="tel">Teléfono</th>
                  <th className="cuit">CUIT</th>
                  <th className="email">Email</th>
                  <th className="loca">Localidad</th>
                  <th className="cli">Contacto 1</th>
                  <th className="tel">Teléfono Contacto 1</th> 
                  <th className="email">Email Contacto 1</th>
                  <th className="cli">Contacto 2</th>
                  <th className="tel">Teléfono Contacto 2</th> 
                  <th className="email">Email Contacto 2</th>
                  
                </tr>
              </thead>
              <tbody>
                {clientes.data.clientes.map((cliente) =>
                  cliente.activo ? (
                    <tr key={cliente._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaCliente(cliente._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarCliente(cliente._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{cliente.codcli}</td>
                      <td>{cliente.razonsocial}</td>
                      <td >{cliente.domicilio}</td>
                      <td>{cliente.telefono}</td>
                      <td>{cliente.cuit}</td>
                      <td>{cliente.email}</td>
                      <td>{cliente.localidad?.localidad || "-"}</td>
                      <td>{cliente.contacto1 || "-"}</td>
                      <td>{cliente.telefono1 || "-"}</td>
                      <td>{cliente.email1 || "-"}</td>
                      <td>{cliente.contacto2 || "-"}</td>
                      <td>{cliente.telefono2 || "-"}</td>
                      <td>{cliente.email2 || "-"}</td>
                    </tr> 
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalCliente
            show={show}
            handleClose={handleClose}
            cliente={cliente}
          />
        </>
      )}
    </div>
  );
};

export default TableClientes;
